export default __webpack_public_path__ + "assets/front/scss/formulaire.362251d371e7a8fd312933641bc72712.css";